import { AppComponent } from '../../app.component';
import { BaseService } from '../../shared/services/base.service';

import { QuoteAcknowledgement } from '../../shared/models/quote.acknowledgement.interface';
import { QuoteSummary } from '../../quote/models/quote.summary.interface';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class WeblinkService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  } 

  getQuote(ackHash: string): Observable<QuoteSummary> {
    return this.httpGet<QuoteSummary>(`/weblink/quote/${ackHash}`);
  }

  getQuoteAcknowledgement(ackHash: string): Observable<QuoteAcknowledgement> {
    return this.httpGet<QuoteAcknowledgement>(`/weblink/acknowledge/${ackHash}`);
  } 

  getDealerLogo(dealerID: number): Observable<Blob> {
    return this.httpGetFile(`/weblink/dealerlogo/${dealerID}`);
  }

  convertQuote(quoteId: number, paymentTypeId: number, paymentTermId: number, bidAmount: number, acceptedAreas: number[]): Observable<number> {
    let data = {
      PaymentType_ID: paymentTypeId,
      PaymentTerm_ID: paymentTermId,
      BidAmount: bidAmount,
      AcceptedAreas: acceptedAreas
    };
    return this.httpPost<number>("/quote/convert/" + quoteId, data);
  }
  
  acceptQuote(quoteAckHash: string, acceptedAreas: number[], signature: string): Observable<number> {
    let data = {
      acceptedAreas: acceptedAreas,
      ack_signature: signature
    };
    return this.httpPut<number>(`/weblink/acceptQuote/${quoteAckHash}`, data)
  }

  rejectQuote(quoteAckHash: string): Observable<number> {
    return this.httpPut<number>(`/weblink/rejectQuote/${quoteAckHash}`, {});
  }

  emailQuote(quoteId: number, contacts: number[], copySender: boolean, 
    message: string, showPricing: boolean, showSquareFootage: boolean, showTaxes: boolean, locale: string): Observable<number> {
    let emailRequest = {
      contacts: contacts,
      copySender: copySender,
      message: message,
      sendViaDocuSign: false,
      updateQuote: true,
      Timezone: - 1 * (new Date().getTimezoneOffset()),
      locale: locale,
      showPricing: showPricing,
      showSquareFootage: showSquareFootage,
      showTaxes: showTaxes
    };

    return this.httpPost<number>("/quote/email/" + quoteId, emailRequest);
  }  
}
